import { Boundaries } from "@planzone/core";
import { events } from "@planzone/events";
import { createStateReducer } from "../../utils/createStateReducer";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";
import { resetState } from "../../utils/resetState";
import { State, Selector } from "./types";
import { createSelector } from "./selector";

const initialState: State = [];

function handleRequest(
  state: State,
  { project }: Boundaries["editProject"]["request"],
): State {
  return [...state, { project, request: setRequestStateToPending() }];
}

function handleSuccess(
  state: State,
  project: Boundaries["editProject"]["success"],
): State {
  return state.map((request) =>
    request.project.uuid === project.uuid
      ? { project, request: setRequestStateToSuccess() }
      : request,
  );
}

function handleFailure(
  state: State,
  { project }: Boundaries["editProject"]["failure"],
): State {
  return state.map((request) =>
    request.project.uuid === project.uuid
      ? { project, request: setRequestStateToFailure() }
      : request,
  );
}

const reduceState = resetState(
  initialState,
  createStateReducer(initialState, {
    [events.editProjectRequested]: handleRequest,
    [events.editProjectSucceeded]: handleSuccess,
    [events.editProjectFailed]: handleFailure,
  }),
  [events.changePlanzoneSucceeded],
);

export type { State, Selector };

export { reduceState, initialState, createSelector };
